import React from 'react';
import { Box, Typography, Paper } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { ChatComponent } from '../types';
import { ChatBotStore } from '../stores/chatBotStore';
import { LoanSummaryCard, SupportedActions } from './chatComponents';
import { SupportedActionsData } from './chatComponents/types';

const useStyles = makeStyles((theme) => ({
  componentCard: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(1),
    borderRadius: '12px',
    border: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.default,
  },
  componentType: {
    fontSize: '12px',
    fontWeight: 600,
    textTransform: 'uppercase',
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(1),
    letterSpacing: '0.5px',
  },
  dataRow: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: theme.spacing(0.5, 0),
  },
  dataKey: {
    fontSize: '13px',
    color: theme.palette.text.secondary,
    fontWeight: 500,
  },
  dataValue: {
    fontSize: '13px',
    color: theme.palette.text.primary,
    fontWeight: 600,
  },
}));

interface ComponentRendererProps {
  component: ChatComponent;
  store: ChatBotStore;
}

export const ComponentRenderer: React.FC<ComponentRendererProps> = ({ component, store }) => {
  const classes = useStyles();

  switch (component.type) {
    case 'loan_summary_card':
      return <LoanSummaryCard data={component.data as any} />;
    case 'supported_actions':
      return <SupportedActions data={component.data as SupportedActionsData} store={store} />;
    default:
      break;
  }

  // Generic fallback for unknown component types
  return (
    <Paper elevation={0} className={classes.componentCard}>
      <Typography className={classes.componentType}>
        {component.type.replace(/_/g, ' ')}
      </Typography>
      {Object.entries(component.data).map(([key, value]) => (
        <Box key={key} className={classes.dataRow}>
          <Typography className={classes.dataKey}>
            {key.replace(/([A-Z])/g, ' $1').replace(/^./, s => s.toUpperCase())}
          </Typography>
          {Array.isArray(value) ? (
            <Box>
              {value.map((item, i) => (
                <Typography key={i} className={classes.dataValue}>
                  {String(item)}
                </Typography>
              ))}
            </Box>
          ) : (
            <Typography className={classes.dataValue}>
              {String(value)}
            </Typography>
          )}
        </Box>
      ))}
    </Paper>
  );
};
